/**
 * Search state lives above the panel so a remount during load
 * does not wipe the query or drop a search that is waiting on a book.
 */
const draft = {
  query: '',
  pending: false,
};

export function readSearchDraft() {
  return { query: draft.query, pending: draft.pending };
}

export function writeSearchQuery(query) {
  draft.query = query;
  if (!String(query || '').trim()) draft.pending = false;
}

export function markSearchPending(pending) {
  draft.pending = Boolean(pending);
}

export function resetSearchDraft() {
  draft.query = '';
  draft.pending = false;
}
